@if (content$ | async; as content) {
<header class="view-header" [formGroup]="manager">
  @for (topic of content; track topic; let topicIdx = $index) { @if (hasPermission( topic.topic )) {
  <div class="choice-item">
    <input
      formControlName="selectedTopic"
      name="selectedTopic"
      type="radio"
      class="choice__input ph-no-capture"
      [value]="topic.topic"
      [id]="'topic-' + topicIdx"
      (change)="onTopicChanged( topic.topic )"
    />
    <label class="choice__label" [for]="'topic-' + topicIdx">{{ topic.topic }}</label>
  </div>
  } }
</header>
} @if (content$ | async; as content) {
<div class="view-body">
  @if (isTopicContextRequired(currentTopic)) {
  <section class="body-col body-col1" [formGroup]="manager">
    <!-- <div [innerHtml]="currentTopic.description | safeHtml" class="context-primary"></div> -->
    @if (currentTopic.features.length > 1) {
    <ul class="context-secondary">
      @for (feature of currentTopic.features; track feature.name; let featureIdx = $index) {
      <li>
        <input
          formControlName="selectedFeature"
          name="selectedFeature"
          type="radio"
          class="ph-no-capture"
          [value]="feature.type"
          [id]="'feature-' + featureIdx"
          (change)="trackFeatureChange( feature )"
        />
        <label [for]="'feature-' + featureIdx"><p [innerHtml]="feature.name | safeHtml"></p></label>
      </li>
      }
    </ul>
    }
  </section>
  }
  <section class="body-col body-col2">
    @if (manager.get('selectedFeature')?.value === 'request') {
    <oke-request [content]="supportRequest.content" />
    } @if (manager.get('selectedFeature')?.value === 'faq') {
    <oke-faqs
      [content]="currentTopicFeature"
      [parentTopic]="currentTopic.topic"
      [isOnlyFeature]="currentTopic.features.length === 1"
    />
    } @if (manager.get('selectedFeature')?.value === 'contacts') {
    <oke-contacts [content]="currentTopicFeature" [isOnlyFeature]="currentTopic.features.length === 1" />
    }
  </section>
</div>
}
